// Historial de una regla con el historial común: fecha, evento, versión que dejó, quién lo hizo y,
// debajo, el cambio de estado y los campos editados.
import { useActorLabel } from '@/hooks/useActorLabel';
import { LifecycleHistory, toLifecycleEvent } from '@/shared/patterns/Lifecycle';
import { useRuleHistory } from '../../api/commissionQueries';
import { ruleEventLines } from '../../lib/ruleChangeText';

export function RuleHistoryList({ ruleId }: { ruleId: string }) {
    const history = useRuleHistory(ruleId);
    const actorLabel = useActorLabel();
    const events = history.data?.events ?? [];
    return (
        <LifecycleHistory
            title="Historial de esta regla"
            isLoading={history.isLoading}
            error={history.isError ? 'No se pudo leer el historial.' : null}
            onRetry={() => {
                void history.refetch();
            }}
            emptyText="Sin eventos registrados para esta regla"
            entries={events.map((event, index) => {
                const lines = ruleEventLines(event);
                return {
                    id: `${event.at}-${String(index)}`,
                    at: event.at,
                    event: toLifecycleEvent(event.action),
                    eventLabel: event.action,
                    detail: event.version === null ? undefined : `v${String(event.version)}`,
                    actor: actorLabel(event.performedBy),
                    below:
                        lines.length > 0 ? (
                            <ul>
                                {lines.map((line) => (
                                    <li key={line}>{line}</li>
                                ))}
                            </ul>
                        ) : undefined,
                };
            })}
        />
    );
}
